import React from 'react';
import LayoutNavbar from './LayoutNavbar';
import LayoutFooter from './LayoutFooter';
import CookieConsent from './CookieConsent';

function Layout({ children }) {
  return (
    <div className="tw-min-h-screen tw-flex tw-flex-col tw-bg-white dark:tw-bg-brand-dark tw-overflow-x-hidden">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <LayoutNavbar />
      <main id="main-content" className="tw-flex-1 tw-pt-16 mobile-tab-padding">
        {children}
      </main>
      <LayoutFooter />
      <CookieConsent />
    </div>
  );
}

export default Layout;
